module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_5.761d7276.pdf";